import OrderDetail from 'gcs-common/components/QuickOrdering/OrderDetail/OrderDetail';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import {
  getChannelInputStagedOrder,
  getChannelInputStagedProcess,
  getChannelInputStagedProduct,
} from 'gcs-common/slices/messageInput/messageInputSelector';
import { channelInputReset } from 'gcs-common/slices/messageInput/messageInputSlice';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import closeIcon from '../../../img/close.svg';
import ProductSelectedDisplay from '../../ProcessDetail/ProductSelectedDisplay/ProductSelectedDisplay';
import ProcessDetailSmall from '../../ProcessDetailSmall/ProcessDetailSmall';
import styles from './styles.module.scss';

const StageSelectedItem = () => {
  const selectedChannelId = useSelector(getSelectedChannelId);
  const channelInputStagedProcess = useSelector(getChannelInputStagedProcess(selectedChannelId));
  const channelInputStagedProduct = useSelector(getChannelInputStagedProduct(selectedChannelId));
  const channelInputStagedOrder = useSelector(getChannelInputStagedOrder(selectedChannelId));

  const dispatch = useDispatch();

  const resetMessage = useCallback(() => {
    dispatch(channelInputReset({ channelId: selectedChannelId }));
  }, [dispatch, selectedChannelId]);

  if (!(channelInputStagedProduct || channelInputStagedProcess || channelInputStagedOrder)) {
    return null;
  }

  return (
    <div className={styles.processDetailWrapper}>
      {channelInputStagedProcess && <ProcessDetailSmall process={channelInputStagedProcess} />}
      {channelInputStagedProduct && <ProductSelectedDisplay product={channelInputStagedProduct} />}
      {channelInputStagedOrder && <OrderDetail order={channelInputStagedOrder} />}
      <button type="button" onClick={resetMessage}>
        <img alt="close-icon" src={closeIcon} className={styles.closeButtonIcon} />
      </button>
    </div>
  );
};

export default StageSelectedItem;
